import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SelectionChangedEvent,
  ColGroupDef,
  ColDef
} from '@ag-grid-enterprise/all-modules';
import CommonGrid from 'shared/commonGrid';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import ActionMenuCellRenderer from 'shared/commonGrid/action-menu-cell-renderer';
import { SnmpV3User } from 'data/snmp/snmp.types';
import SnmpUserGridActionMenu from './SnmpUserGridActionMenu';

interface Props {
  data: SnmpV3User[];
  hasPrivilegeToView: boolean;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  noResults: boolean;
  beforeLogout: boolean;
  lastUpdatedAt: Date | undefined;
  columnDefs: (ColGroupDef | ColDef)[];
  selectedSnmpUser: SnmpV3User | null;
  onRefresh: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onCreateNew: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onSelectionChanged: (event: SelectionChangedEvent) => void;
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

const SnmpUserListGrid: FunctionComponent<Props> = ({
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  hasPrivilegeToView,
  data = [],
  noResults,
  beforeLogout,
  lastUpdatedAt,
  columnDefs,
  selectedSnmpUser,
  onCreateNew,
  onRefresh,
  onSelectionChanged,
  onView,
  onEdit,
  onDelete
}: Props) => {
  const components = {
    actionMenuCellRenderer: ActionMenuCellRenderer
  };
  const { t } = useTranslation();

  return (
    <div
      className="grid-container"
      style={{ height: 'inherit' }}
      data-testid="SnmpUserList"
    >
      <CommonGrid
        createNewText={t('snmpUser.grid.newSnmpUser')}
        pagination
        enableBrowserTooltips
        rowSelection={ROWSELECTION.SINGLE}
        hasPrivilegeToCreateNew={hasPrivilegesToCreate}
        hasPrivilegeToDelete={hasPrivilegeToDelete}
        hasPrivilegetoView={hasPrivilegeToView}
        rowData={data}
        noResults={noResults}
        isBeforeLogout={beforeLogout}
        columnDefs={columnDefs}
        components={components}
        handleCreateNew={onCreateNew}
        onRefresh={onRefresh}
        onSelectionChanged={onSelectionChanged}
        onActionMenuItemClick={onView}
        lastUpdatedAt={lastUpdatedAt}
      >
        <SnmpUserGridActionMenu
          selectedItem={selectedSnmpUser}
          hasPrivilegesToCreate={hasPrivilegesToCreate}
          hasPrivilegeToDelete={hasPrivilegeToDelete}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      </CommonGrid>
    </div>
  );
};

export default SnmpUserListGrid;
